import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import MarketMenuItemDetailed from './pages/MarketMenuItemDetailed';
import LoadingPage from './pages/LoadingPage';
import { fetchItem } from '../lib/ShopifyUtility'; 

const MarketMenuItemDetailedWrapper = ({ addToBasket }) => {
    const { catHandle, itemHandle } = useParams();
    const [currentItem, setCurrentItem] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
  
    useEffect(() => {
      setIsLoading(true); // Set isLoading to true before fetching the new item
      setCurrentItem(null); // Reset currentItem to null before fetching the new item
      // Fetch the item based on the catHandle and itemHandle from the URL
      fetchItem(itemHandle).then((item) => {
        setCurrentItem(item);
      })
      .finally(() => {
        setIsLoading(false); // Set isLoading to false when the item is fetched
      });
    }, [itemHandle]);
  
    return (
      <>
        {isLoading ? (
          <LoadingPage height='700px' />
        ) : (
          <MarketMenuItemDetailed
            item={currentItem}
            onAddToBasket={addToBasket}
            currentCatHandle={catHandle}
          />
        )}
      </>
    );
}

export default MarketMenuItemDetailedWrapper;